import script from "./BangPhanChiaCongViec.vue?vue&type=script&setup=true&lang=js"
export * from "./BangPhanChiaCongViec.vue?vue&type=script&setup=true&lang=js"

import "./BangPhanChiaCongViec.vue?vue&type=style&index=0&id=27ecaa0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ecaa0e"]])

export default __exports__